import React from 'react';
import styled, { css } from 'styled-components';
import { Flex } from 'rebass';
import { getISODay, isWithinRange, format, endOfDay } from 'date-fns';
import CalendarDay from '../Day';
import CalendarNavigator from '../Navigator';
import WeekEvents from '../WeekEvents';
import Text from '../../../Text';
import CalendarCitiesLegend from '../CitiesLegend';

const Month = styled(Flex)`
  ${({ theme }) => css`
    flex-direction: column;
    border-top: ${theme.border};
    border-left: ${theme.border};
  `}
`;

const Week = styled(Flex)`
  position: relative;
  overflow: hidden;
`;

const Weekday = styled(Text)`
  width: 25px;
`;

const CalendarLayout = ({ setPeriod, month, year, weeks, events }) => {
  return (
    <>
      <CalendarNavigator
        setPeriod={setPeriod}
        month={month}
        year={year}
        mb={3}
      />
      <Week justifyContent="space-around" mb={2}>
        {weeks[0].map(day => (
          <Weekday
            textAlign="center"
            fontSize={[1, 2]}
            variant="secondary"
            key={`weekday-${getISODay(day)}`}
          >
            {format(day, 'ddd')}
          </Weekday>
        ))}
      </Week>
      <Month>
        {weeks.map((week, weekIdx) => {
          const weekEvents = events.filter(event => {
            const { start_date, end_date } = event;
            const startDate = new Date(start_date);
            const endDate = new Date(end_date);
            return (
              isWithinRange(
                startDate,
                week[0],
                endOfDay(week[week.length - 1]),
              ) ||
              isWithinRange(endDate, week[0], endOfDay(week[week.length - 1]))
            );
          });
          return (
            <Week key={`${month}-week-${weekIdx}`}>
              <WeekEvents week={week} events={weekEvents} />
              {week.map(day => {
                return (
                  <CalendarDay
                    key={`week-${weekIdx}-day-${getISODay(day)}`}
                    value={day}
                  />
                );
              })}
            </Week>
          );
        })}
      </Month>
      <CalendarCitiesLegend mt={3} events={events} />
    </>
  );
};

export default CalendarLayout;
